export default {
  // 导航栏文案
  nav: {
    home: '首页',
    groupIntroduction: '集团简介',
    portLogistics: '港航物流',
    industrialBase: '产业园',
    characteristicTown: '特色小镇',
    newsCenter: '资讯中心',
    downloadCenter: '资料下载',
    aboutUs: '联系我们'
  },
  footer: {
    linkTitle: '友情链接',
    nav: {
      home: '网站首页',
      about: '联系我们',
      recruit: '人才招聘',
      contact: '联系我们',
      message: '在线留言',
      download: '下载中心',
      rss: '订阅RSS'
    },
    contact: {
      address: '地址：',
      phone: '电话：',
      email: '电邮：',
      addressValue: '香港中环皇后大道中302号北海商业大厦6楼',
      phoneValue: '(+852)2139 5018',
      emailValue: 'chenxm@pntg.com.hk'
    },
    copyright: 'Copyright 2010-2016 普泰（香港）集团有限公司 All Rights Reserved',
    record: '浙ICP备15012664号-2',
  },
  friendLinks: {
    realEstate: '中国房地产协会',
    logistics: '物流与采购联合会',
    environmental: '环保产业协会',
    building: '中国建筑科学研究院',
    trade: '国际贸易促进委员会',
    huzhou: '湖州经济开发区',
    haining: '海宁市府官网',
    suzhou: '苏州市商务局',
    guangxi: '广西投资促进局',
    economy: '中国经济网',
    enterpriseNews: '企业新闻网'
  },
  project: {
    mainTitle: '集团项目',
    subtitle: '普泰集团多元化业务布局，涵盖物流地产、商业地产、工程建设和商品流通四大领域',
    viewProject: '查看项目 →',
    items: {
      logistics: {
        title: '物流地产',
        desc: '现代化智能物流园区建设与运营管理'
      },
      commercial: {
        title: '商业地产',
        desc: '城市综合体与商业配套设施开发与项目管理'
      },
      environmental: {
        title: '环保科技',
        desc: '绿色环保技术研发与应用推广'
      },
      engineering: {
        title: '工程建设',
        desc: '各类工程项目总包与管理服务'
      },
      circulation: {
        title: '商品流通',
        desc: '高品质商品供应链管理服务'
      }
    },
    ProjectClassification: '项目分类'
  },
  video: {
    mainTitle: '集团视频展示',
    subtitle: '通过视频了解普泰集团的发展历程、企业文化和项目成就',
    items: {
      promo2025: {
        title: '普泰集团2025年度宣传片',
        desc: '探索普泰集团的发展历程、核心业务与未来愿景，见证我们如何通过创新与卓越领跑行业。'
      },
      huzhouLogistics: {
        title: '湖州物流产业园项目介绍',
        desc: '详细介绍普泰集团湖州物流产业园的规划设计、建设进展和未来运营模式。'
      },
      ecoTech: {
        title: '普泰环保科技业务展示',
        desc: '展示普泰集团在环保科技领域的创新成果和可持续发展解决方案。'
      }
    }
  },
  filter: {
    filterByYear: '按年份筛选', // 按年份筛选
    filterByType: '按类型筛选', // 按类型筛选
    allNews: '全部资讯',    // 全部资讯
    allTypes: '全部类型',   // 全部类型
    yearSuffix: '年'
  },
  downloadCenter: {
    dataCategory: '资料分类', // 资料分类
    allData: '全部资料',       // 全部资料
    noDataTip: '当前分类下暂无可下载的资料' // 空数据提示（可选，统一管理）
  },
  infoCards: {
    groupProfile: '集团简介',
    groupNews: '集团动态',
    downloadCenter: '下载中心',
    moreNews: '更多动态',
    moreFiles: '更多文件',
    groupName: '普泰（香港）集團',
    groupDesc: '普泰集团是由菜亮军先生、宣晓飞先生于2005年联合创办。是以港口物流、产业园等领域为主的投资集团。<br><br>普泰专注于成为中国具有一定影响力产业投资开发及运营商，并始终倡导生态环保技术的开发与应用...'
  },
  groupIntro: {
    imgDesc: '普泰集团港口物流产业园实景',
    paragraph1: '普泰（香港）集团有限公司是以港口物流、物流地产等领域为主的投资集团。',
    paragraph2: '普泰在专注于成为中国大陆区域性最大的港口物流投资开发商及最具影响力的第三方物流解决方案提供商的同时，倡导生态环保技术的开发与应用。“低碳、绿色、环保”是普泰崇尚的核心理念，也是普泰的核心价值观。',
    paragraph3: '普泰坚持不懈地打造绿色建造，以环境和谐为本，优化物流链、降低物流成本、提升物流效率、降低排放、改善环境，致力于成为行业创新者、领跑者及卓越的绿色企业，让天更蓝、水更绿。',
    corePosition: '核心定位',
    corePositionDesc: '中国大陆区域性最大的港口物流投资开发商',
    serviceObjective: '服务目标',
    serviceObjectiveDesc: '最具影响力的第三方物流解决方案提供商',
    devPhilosophy: '发展理念',
    devPhilosophyDesc: '绿色建造、环境和谐、行业创新领跑'
  },
  portLogistics: {
    // 分类标签
    overview: '港航物流概况',
    jiaxing: '嘉兴内河港',
    deqing: '德清港',
    haining: '海宁港',

    // 港航物流概况
    overviewTitle: '港航物流概况',
    feature1: '通过投资建设有港口装卸、仓储配送、市场交易及商务配套功能的港口物流园，实现交通运输现代化、标准化、集约化。',
    feature2: '依托口岸“通关一体化”便利，让内陆城市“通江达海”，提升国际竞争力。',
    feature3: '依托“海河联运、车船港一体化、港港联动”等集疏运模式，优化物流链，提高物流效率，降低物流成本。',
    feature4: '通过“陆改水、散改集”业务操作，降低碳排放，实现绿色低碳运输。',
    feature5: '通过融合“人流、物流、资金流、信息流”，整合各方资源，形成资金高地、信息中心，打造临港产业集聚平台。',
    feature6: '作为区域地理经济的公共服务平台，依托经济一体化的便利，服务国内国际双循环。',
    advantageTitle: '综合物流优势',
    advantage1: '拆装箱及仓储',
    advantage2: '口岸及物流金融',
    advantage3: '内支线对接母港',
    advantage4: '冷库及冷链配送',

    // 嘉兴内河港
    jiaxingTitle: '嘉兴内河港 · 国际多用途港区',
    jiaxingOverview: '位于嘉兴市南湖区，是浙江省重点基建项目及国家交通运输部规划的全国主要内河港口之一。',
    jiaxingParam1: '总占地面积：32.6万平方米',
    jiaxingParam2: '泊位岸线长度：570米',
    jiaxingParam3: '设计年吞吐量：35万标箱',
    jiaxingParam4: '当前年吞吐量：22万标箱',
    jiaxingFacilityTitle: '配套设施：',
    jiaxingFacility1: '口岸管理机关',
    jiaxingFacility2: '配套货物查验熏蒸',
    jiaxingFacility3: '高标准仓库',
    jiaxingFacility4: '货物检查',
    jiaxingFacility5: '熏蒸消毒',
    jiaxingFacility6: '信息平台',
    jiaxingPosition: '致力于成为提供全面口岸功能与物流服务的主要集散港，支援上海国际航运中心建设。',
    jiaxingImg1Alt: '嘉兴内河港集装箱作业区',
    jiaxingImg2Alt: '嘉兴内河港航拍图',
    jiaxingImg3Alt: '嘉兴内河港口岸办公楼',

    // 德清港
    deqingTitle: '德清港',
    deqingParam1: '岸线长度：510米',
    deqingParam2: '千吨级多用途泊位：7个',
    deqingParam3: '年吞吐量：350万吨',
    deqingParam4: '集装箱吞吐量：30万TEU',
    deqingModeTitle: '“车船港”一体化运作模式',
    deqingModeDesc: '通过杭平申线、湖嘉申线和京杭大运河等内河航道，集装箱可在18-28小时内到达乍浦、上海、太仓等沿海港口，实现海河联运，为德清及周边地区企业的大宗货物进出口提供便利。',
    deqingDevelopTitle: '发展成果',
    deqingDevelopDesc1: '2015年12月16日开港运营以来，德清港开拓创新，充分发挥“陆海河联运、区港园联动、车船港一体化”等优势：',
    deqingDevelop1: '通过打造仓储、配送、报关、检验检疫等一票式服务',
    deqingDevelop2: '在引进船公司、开辟新航线、扩大货源市场、延伸物流服务等方面下功夫',
    deqingDevelop3: '为内河集装箱发展激活活力、打下坚实基础',
    deqingDevelopDesc2: '次年吞吐量突破10万标箱，德清迎来了全新的港口时代。',
    deqingImg1Alt: '德清港集装箱作业区',
    deqingImg2Alt: '德清港园区航拍图',

    // 海宁港
    hainingTitle: '海宁港物流园',
    hainingParam1: '总投资：2.5亿美元',
    hainingParam2: '总占地面积：550亩',
    hainingParam3: '岸线长度：386米',
    hainingParam4: '千吨级多用途泊位：8个',
    hainingParam5: '集装箱年吞吐量：30万标箱',
    hainingFunctionTitle: '具备五大功能',
    hainingFunction1: '口岸',
    hainingFunction2: '集装箱',
    hainingFunction3: '冷链及仓储',
    hainingFunction4: '商品贸易',
    hainingFunction5: '信息平台',
    hainingQualificationTitle: '项目资质',
    hainingQualification1: '浙江省重点工程',
    hainingQualification2: '浙江省服务业重大项目',
    hainingQualification3: '浙江省十二五海洋经济发展重大建设项目',
    hainingImg1Alt: '海宁港区位交通图',
    hainingImg2Alt: '海宁港区域位置图',
    hainingImg3Alt: '海宁港作业区'
  },
  industrialBase: {
    // 通用标题/标签
    categoryTitle: '产业基地',
    projectLocation: '项目区位：',
    trafficAdvantage: '交通优势：',
    coreParameters: '核心参数：',
    buildingFacilities: '建筑设施：',
    keyIntroducedIndustries: '重点引进产业：',
    benefitAfterCompletion: '达产后效益：',
    carrierPositioning: '载体定位：',
    trafficLocationAdvantage: '交通区位优势：',
    industrialPositioning: '产业定位：',
    parkGoal: '园区目标：',
    locationDistanceAdvantage: '区位距离优势：',
    parkPositioning: '园区定位：',

    // 产业园名称
    suzhou: '科栖（苏州）产业园',
    suzhouNewMaterial: '苏州国际新材料产业园',
    xishan: '普泰易商锡山智能制造基地',
    bowang: '科栖（博望）产业园',
    fangchenggang: '科栖（防城港）产业园',

    // 科栖（苏州）产业园详情
    suzhouLocation: '项目位于苏州高新区，是区域重点产业载体之一。',
    suzhouTraffic1: '地铁3号线文昌路站在产业园内',
    suzhouTraffic2: '毗邻京杭大运河、苏州中环线',
    suzhouTraffic3: '距高铁苏州新区站仅两站地铁路程，交通极为便利',
    suzhouParam1: '总占地面积：184亩',
    suzhouParam2: '规划建设面积：约30万方',
    suzhouParam3: '计划总投资：15亿元（分3期开发）',
    suzhouParam4: '预计引进企业：100家左右优质高科技企业',
    suzhouParam5: '达产后年税收：2亿元以上',
    suzhouImg1Alt: '科栖（苏州）产业园区位图',
    suzhouImg2Alt: '科栖（苏州）产业园整体效果图',
    suzhouImg3Alt: '科栖（苏州）产业园实景图',
    suzhouImg4Alt: '科栖（苏州）产业园建筑外观',

    // 苏州国际新材料产业园详情
    suzhouNewMaterialLocation: '位于苏州高新区苏化路，已成为浒墅关经开区重要的产业承接载体。',
    suzhouNewMaterialParam1: '总开发面积：约60亩',
    suzhouNewMaterialParam2: '总建筑面积：150000平米',
    suzhouNewMaterialFacilities: '主要为一栋甲类仓库及两栋四层级高标准丙类工业设施',
    suzhouNewMaterialIndustry1: '汽车零部件',
    suzhouNewMaterialIndustry2: '智能装备制造',
    suzhouNewMaterialIndustry3: '半导体',
    suzhouNewMaterialIndustry4: '生物医药',
    suzhouNewMaterialIndustry5: '医疗器械',
    suzhouNewMaterialIndustry6: '新材料',
    suzhouNewMaterialBenefit1: '预计新增注册资本超5亿元',
    suzhouNewMaterialBenefit2: '年产值超30亿元',
    suzhouNewMaterialBenefit3: '年缴纳税收超2亿元',
    suzhouNewMaterialBenefit4: '新增高新技术企业6家以上',
    suzhouNewMaterialImg1Alt: '苏州国际新材料产业园整体效果图',
    suzhouNewMaterialImg2Alt: '苏州国际新材料产业园仓库实景',
    suzhouNewMaterialImg3Alt: '苏州国际新材料产业园工业设施外观',

    // 普泰易商锡山智能制造基地详情
    xishanLocation: '位于无锡市锡山经济技术开发区。',
    xishanParam1: '建设用地面积：约93亩',
    xishanParam2: '总建筑面积：98571平方米',
    xishanParam3: '建设内容：生产厂房及相关配套设施',
    xishanParam4: '总投资：约1.5亿美元',
    xishanCarrierPosition: '锡山智能制造基地为高标准载体平台',
    xishanIndustry1: '高端装备制造',
    xishanIndustry2: '汽车零部件',
    xishanIndustry3: '电子通讯设备',
    xishanBenefit1: '预计年产值：近10亿元人民币',
    xishanBenefit2: '预期年纳税：近4700万元人民币',
    xishanBenefit3: '年综合税收：约50万元/亩',
    xishanBenefit4: '拟吸纳就业人数：超1000人',
    xishanImg1Alt: '锡山智能制造基地整体效果图',
    xishanImg2Alt: '锡山智能制造基地配套设施',
    xishanImg3Alt: '锡山智能制造基地建筑外观',

    // 科栖（博望）产业园详情
    bowangLocation: '位于马鞍山市博望区，是博望现代产业融合示范区核心载体之一。',
    bowangParam1: '总占地面积：200亩',
    bowangParam2: '项目总投资：12亿元',
    bowangParam3: '一期占地面积：100亩',
    bowangParam4: '一期建筑面积：约5.5万方',
    bowangParam5: '一期总投资：6亿元',
    bowangTraffic1: '距马鞍山站约40KM',
    bowangTraffic2: '距禄口机场约30KM',
    bowangTraffic3: '距溧水站约40KM、当涂东站约36KM',
    bowangIndustrialPosition: '以高标准厂房为载体，聚焦装备制造、智能制造、新一代信息技术、新材料等产业。',
    bowangParkGoal: '致力于打造博望现代产业融合示范区，建设现代化新型产业空间，招引和集聚一批高成长潜力的中小企业，成为博望产业升级进位的新引擎。',
    bowangImg1Alt: '科栖（博望）产业园交通区位图',
    bowangImg2Alt: '科栖（博望）产业园规划图',
    bowangImg3Alt: '科栖（博望）产业园厂房效果图',

    // 科栖（防城港）产业园详情
    fangchenggangLocation: '位于防城港市东部，临近防城港港口，是防城港市小微企业新中心核心载体。',
    fangchenggangDistance1: '距离防城港市区10.9公里',
    fangchenggangDistance2: '距离防城港港口15.1公里',
    fangchenggangParam1: '总占地面积：111亩',
    fangchenggangParam2: '规划建筑面积：约6.6万方',
    fangchenggangParam3: '总投资：2.2亿元人民币',
    fangchenggangParkPosition: '打造集生产、展示、商务、办公为一体化的生产基地型综合园区，塑造防城港工业园区新形象，构建规范化、专业化、集群化生产园区，成为防城港市小微企业新中心。',
    fangchenggangImg1Alt: '科栖（防城港）产业园区位图'
  },
  characteristicTown: {
    // 通用标题/标签
    categoryTitle: '特色小镇',
    projectLocation: '项目区位：',
    projectOverview: '项目概况：',
    surroundingEcologicalEnvironment: '周边生态环境：',
    planningMapAlt: '浒墅关绿色技术小镇规划图',

    // 浒墅关特色小镇相关
    xushuguan: '浒墅关特色小镇',
    xushuguanGreenTechTown: '浒墅关绿色技术小镇',
    xushuguanLocationDesc: '位于苏州市高新区浒墅关经开区核心区域，小镇边界为：',
    eastTo: '东至：苏浒路',
    southTo: '南至：312国道-大新河',
    westTo: '西至：312国道-文昌路',
    northTo: '北至：通浒路',
    xushuguanOverviewDesc: '由普泰集团与浒墅关经开区管委会联合打造',
    planningArea: '规划面积：3.4平方公里',
    constructionLandArea: '建设用地面积：约2100亩',
    totalInvestment: '总投资额：350亿',

    // 上城·浒关运河文化古镇
    upperTown: '上城·浒关运河文化古镇',
    upperTownDesc: '推动城市更新，形成苏州城市西北门户，成为苏州文化休闲新地标和中国大运河文化复兴典范',
    upperTownInvestment: '总投资：约160亿',

    // 下城·绿色产业新城
    lowerTown: '下城·绿色产业新城',
    lowerTownDesc: '导入联合国工发绿色产业园理念，围绕新一代信息技术、智能制造、医疗器械、5G产业，打造工业4.0概念的产业新城',
    lowerTownInvestment: '总投资：约190亿',

    // 周边生态环境
    ecologicalEnv1: '东部7公里处，是近两万亩的苏州北部绿肺虎丘湿地公园',
    ecologicalEnv2: '西侧4公里处为江苏大阳山国家森林公园，西距太湖13公里，是苏州大生态休闲线路上的重要节点'
  },
  common: {
    backHome: '返回首页',
    backList: '返回列表'
  }
}